function fetchConfig(type = 'json') {
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
    };
  }

  if (!customElements.get('product-form')) {
    customElements.define(
      'product-form',
      class ProductForm extends HTMLElement {
        constructor() {
          super();

          this.form = this.querySelector('form');
          this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
          this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer') || document.querySelector('cart-items')
          this.submitButton = this.querySelector('[type="submit"]');
          this.submitButtonText = this.submitButton.querySelector('span');

          if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
          this.hideErrors = this.dataset.hideErrors === 'true';
        }
        onSubmitHandler(evt) {
          evt.preventDefault();
          if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

          this.handleErrorMessage();
          this.submitButton.setAttribute('aria-disabled', true);
          this.querySelector('[type="submit"]').classList.add('loading');
          this.querySelector('.loading__spinner').classList.remove('hidden');

          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];

          const formData = new FormData(this.form);
          if (this.cart) {
            formData.append(
              'sections',
              this.cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }
          config.body = formData;
          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  errors: response.errors || response.description,
                  message: response.message,
                });
                this.handleErrorMessage(response.description);

                const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                if (soldOutMessage) {
                  this.submitButton.setAttribute('aria-disabled', true);
                  this.submitButtonText.classList.add('hidden');
                  soldOutMessage.classList.remove('hidden');
                }
                this.error = true;
                // return;
              } else if (!this.cart) {
                window.location = window.routes.cart_url;
                  //  const cartItems = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
                  //  cartItems.onCartUpdate();
                  // return;
              }

              if (!response.sections) {
                    const sectionsToRender = this.cart.getSectionsToRender().map((section) => section.id);
                    const sectionsUrl = `${window.routes.cart_url}?sections=${sectionsToRender.join(',')}&sections_url=${window.location.pathname}`;

                    return fetch(sectionsUrl)
                    .then((res) => res.json())
                    .then((sectionsResponse) => {
                      const formattedState = {
                        sections: sectionsResponse
                      };
                      CartPerformance.measure("add:paint-updated-sections", () => {
                        this.cart.renderContents(formattedState);
                      });
                    });
                   this.error = false;
              } else {
                const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
                if (!this.error)
                  publish(PUB_SUB_EVENTS.cartUpdate, {
                    source: 'product-form',
                    productVariantId: formData.get('id'),
                    cartData: response,
                  }).then(() => {
                    CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
                  });
                this.error = false;
                const quickAddModal = this.closest('quick-add-modal');
                if (quickAddModal) {
                  document.body.addEventListener(
                    'modalClosed',
                    () => {
                      setTimeout(() => {
                        CartPerformance.measure('add:paint-updated-sections', () => {
                          this.cart.renderContents(response);
                        });
                      });
                    },
                    { once: true }
                  );
                  quickAddModal.hide(true);
                } else {
                  CartPerformance.measure('add:paint-updated-sections', () => {
                    this.cart.renderContents(response);
                  });
                }
              }
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              this.querySelector('[type="submit"]').classList.remove('loading');
              if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
              this.submitButton.removeAttribute('aria-disabled');
              this.querySelector('.loading__spinner').classList.add('hidden');

              CartPerformance.measureFromEvent('add:user-action', evt);
            }); 
        }

        handleErrorMessage(errorMessage = false) {
          if (this.hideErrors) return;

          this.errorMessageWrapper =
            this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
          if (!this.errorMessageWrapper) return;
          this.errorMessage =
            this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

          this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

          if (errorMessage) {
            this.errorMessage.textContent = errorMessage;
          }
        }

        toggleSubmitButton(disable = true, text) {
          if (disable) {
            this.submitButton.setAttribute('disabled', 'disabled');
            if (text) this.submitButtonText.textContent = text;
          } else {
            this.submitButton.removeAttribute('disabled');
            this.submitButtonText.textContent = window.variantStrings.addToCart;
          }
        }
      }
    );
  }

 if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      constructor() {
        super();

        this.sectionId = this.dataset.sectionId;
        this.variants = this.getVariants();
        this.slidersInitialized = false;

        this.addEventListener('change', this.onVariantChange.bind(this));
        this.addEventListener('click', this.clickEvent.bind(this));

        // Init sliders once
        this.initSliders();
      }

      getVariants() {
        const json = this.querySelector('[data-product-variants]');
        return json ? JSON.parse(json.textContent) : [];
      }

      getSelectedOptions() {
        const selected = [];
        this.querySelectorAll('.product-variants').forEach((group) => {
          const checked = group.querySelector('input:checked');
          if (checked) selected.push(checked.value);
        });
        return selected;
      }

      onVariantChange(e) {
        if (!e.target.matches('input[type="radio"]')) return;

        const options = this.getSelectedOptions();
        const variant = this.variants.find((v) =>
          v.options.every((opt, i) => opt === options[i])
        );

        if (!variant) return;

        this.updateURL(variant.id);
        this.updateVariantInput(variant.id);
        this.renderSection(variant.id);
      }

      updateVariantInput(variantId) {
        const input = this.querySelector('input[name="id"]');
        if (input) input.value = variantId;
      }

      updateURL(variantId) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variantId);
        history.replaceState({}, '', url);
      }

      renderSection(variantId) {
        const url = `${window.location.pathname}?variant=${variantId}&section_id=${this.sectionId}`;

        fetch(url)
          .then((r) => r.text())
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');

            this.replaceBlock(doc, `.${this.sectionId}-price`);
            this.replaceBlock(doc, `.${this.sectionId}-pdp-stock`);
            this.replaceBlock(doc, `.${this.sectionId}-submit-button`);
          });
      }

      replaceBlock(sourceDoc, selector) {
        const newEl = sourceDoc.querySelector(selector);
        const currentEl = this.querySelector(selector);
        if (newEl && currentEl) {
          currentEl.innerHTML = newEl.innerHTML;
        }
      }

      /* ----------------------------
        SWIPER (INIT ONCE)
      ----------------------------- */
      initSliders() {
        if (this.slidersInitialized) return;

        const thumbEl = this.querySelector('.thumb-swiper');
        const galleryEl = this.querySelector('.gallery-slider');

        let thumbSwiper = null;

        // Thumb slider (optional)
        if (thumbEl) {
          thumbSwiper = new Swiper(thumbEl, {
            spaceBetween: 12,
            slidesPerView: 3,
            freeMode: true,
            watchSlidesProgress: true,
            breakpoints: {
              576: { slidesPerView: 4.8 },
              768: { slidesPerView: 3.2 },
              992: { slidesPerView: 3.8 },
            },
          });
        }

        // Gallery slider (optional)
        if (galleryEl) {
          new Swiper(galleryEl, {
            spaceBetween: 10,
            slidesPerView: 1,
            thumbs: thumbSwiper ? { swiper: thumbSwiper } : undefined,
          });
        }

        this.slidersInitialized = true;
      }

      clickEvent(e) {
        var infoIcon = this.querySelector('.product-stock-info .info_icon'),
            info = this.querySelector('.stock_col_info');

        if(e.target.closest('.info_icon') && info){          
            if (!info.classList.contains('active')) {
              info.classList.add('active')
              info.style.height = info.scrollHeight + 'px';
            } else {
              info.classList.remove('active')
              info.style.height = '0px';
            }
        }
      }
    }
  );
}


  if (!customElements.get('quantity-input')) {
    customElements.define(
      'quantity-input',
      class QuantityInput extends HTMLElement {
        constructor() {
          super();
          this.input = null;
          this.btnMinus = null;
          this.btnPlus = null;
        }

        connectedCallback() {
          this.input = this.querySelector('input[type="number"]');
          this.btnMinus = this.querySelector('.minus');
          this.btnPlus = this.querySelector('.plus');

          if (!this.input) return;

          // Ensure min = 1
          this.input.setAttribute('min', '1');

          this.btnMinus?.addEventListener('click', this.decrease.bind(this));
          this.btnPlus?.addEventListener('click', this.increase.bind(this));
        }

        decrease(e) {
          e.preventDefault();
          let current = parseInt(this.input.value, 10) || 1;

          if (current > 1) {
            this.input.value = current - 1;
            this.triggerChange();
          }
        }

        increase(e) {
          e.preventDefault();
          let current = parseInt(this.input.value, 10) || 1;
          this.input.value = current + 1;
          this.triggerChange();
        }

        triggerChange() {
          this.input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    );
  }